import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import close from "../../assets/icons/close.svg";
import "../../assets/css/addEuipment.css";
// import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import plus1 from "../../assets/icons/plus1.svg";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";
import edit from "../../assets/icons/edit.svg";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import lucide_download from "../../assets/icons/lucide_download.svg";

import trash from "../../assets/icons/trash.svg";
const EditEquipment = () => {
	const [masterOptionsMap, setMasterOptionsMap] = useState({});
	const [errorrowMessages, setErrorrowMessages] = useState([]);
	const [editRowTemplateId, setEditRowTemplateId] = useState(null);
	const [assets, setAssets] = useState([]);
	const [assetId, setAssetId] = useState("");
	const [assetAttributes, setAssetAttributes] = useState([]);
	const [assetTemplates, setAssetTemplates] = useState([]);

	const [editRowIndex, setEditRowIndex] = useState(null);
	const [editRowValues, setEditRowValues] = useState({});

	const [templateMasters, setTemplateMasters] = useState({});
	const [assetMasters, setAssetMasters] = useState([]);

	const [formValues, setFormValues] = useState({});
	const [selectedValues, setSelectedValues] = useState({});
	const [rows, setRows] = useState({});

	const [errforsubmit, seterrforsubmit] = useState("");
	const [errors, setErrors] = useState({});


	const { equipment_id } = useParams();
	// const [equipment, setEquipment] = useState({});

	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();
	const [errorMessages, setErrorMessages] = useState([]);

	const [showUploadModal, setShowUploadModal] = useState(false);
	const [selectedTemplateId, setSelectedTemplateId] = useState(null);
	const [selectedTemplateName, setSelectedTemplateName] = useState(null);


	const customStyles = {
		control: (base, state) => ({
			...base,
			height: "48px",
			width: "250px",
			minHeight: "48px",
			lineHeight: "30px",
			borderRadius: "12px",
			boxShadow: state.isFocused ? "0 2px 10px rgba(0, 0, 0, 0.1)" : "none",
			borderColor: state.isFocused ? "#CED4DA" : base.borderColor,
			"&:hover": {
				borderColor: state.isFocused ? "#CED4DA" : base.borderColor,
			},
		}),
		menu: (provided) => ({
			...provided,
			zIndex: 9999,
		}),
		menuPortal: (base) => ({ ...base, zIndex: 9999 }),
		menuList: (base) => ({
			...base,
			padding: 0,
			maxHeight: "300px",
			overflowY: "auto",
		}),
		option: (base, state) => ({
			...base,
			padding: "10px",
			color: "#171717",
			backgroundColor:
				state.isSelected || state.isFocused ? "#f4f4f4" : "white",
			cursor: "pointer",
			"&:hover": {
				backgroundColor: "#f0f0f0",
			},
			lineHeight: "15px",
		}),
		placeholder: (base) => ({
			...base,
			lineHeight: "15px",
		}),
		input: (base) => ({
			...base,
			lineHeight: "15px",
			padding: "0",
		}),
	};

	useEffect(() => {
		const getAssetClass = async () => {
			try {
				const data = await fetchWrapper(
					`${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset/getall`,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({}),
					},
					navigate
				);

				setAssets(data || []);
				getEquipment(); // Call getEquipment after fetching assets
			} catch (error) {
				console.error("Error fetching data:", error.message);
				if (error.message === "Unauthorized") {
					navigate("/auth/login");
				}
			}
		};
		getAssetClass();
	}, [navigate]);

	const getEquipment = async () => {
		try {
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/view/${equipment_id}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate
			);

			// setEquipment(data.data || {});
			setFormValues(data.data || {}); // Set form values with the fetched data
			setRows(data.data.templates || []); // Set rows with the fetched data
			setAssetId(data.data.asset_id); // Set the assetId state
			handleAssetClassChange(data.data.asset_id);
		} catch (error) {
			console.error("Error fetching data:", error.message);
			if (error.message === "Unauthorized") {
				navigate("/auth/login");
			}
		}
	};
	const handleEditInputChange1 = (id, selectedOption, isDropdown = false) => {
		setEditRowValues((prevValues) => {
			const updatedValue = {
				value: isDropdown
					? selectedOption?.label || "" // ✅ store label, not value/id
					: selectedOption
			};

			return {
				...prevValues,
				[id]: updatedValue,
			};
		});
	};
	const handleAssetClassChange = async (asset_id) => {
		setAssetId(asset_id);
		try {
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-class-attribute/${asset_id}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate
			);

			setAssetAttributes(data.asset_attributes || []);

			try {
				await getAssetTemplates(asset_id);
			} catch (error) {
				console.error("Error fetching asset templates:", error.message);
				toast.error("Failed to fetch asset templates.");
			}

			try {
				await getAssetMasters(asset_id);
			} catch (error) {
				console.error("Error fetching asset masters:", error.message);
				toast.error("Failed to fetch asset masters.");
			}
		} catch (error) {
			console.error("Error fetching data:", error.message);
			toast.error("An error occurred while fetching data.");
			if (error.message === "Unauthorized") {
				navigate("/auth/login");
			}
		}
	};

	const getAssetTemplates = async (asset_id) => {
		try {
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-templates/${asset_id}/attributes`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate
			);

			// Check if the response is okay
			// if (!data) {
			//   throw new Error(
			//     "Failed to fetch getAssetTemplates data from the collection."
			//   );
			// }

			// Set asset templates state

			setAssetTemplates(data || []);

			// Fetch template masters for each template
			const templateMastersPromises = data.map((template) =>
				getTemplateMasters(template, asset_id)
			);

			// Wait for all template masters promises to resolve
			const templateMastersData = await Promise.all(templateMastersPromises);

			// Create a map of template masters
			const templateMastersMap = data.reduce((acc, template, index) => {
				acc[template._id] = templateMastersData[index];
				return acc;
			}, {});

			// Set template masters state
			setTemplateMasters(templateMastersMap);
		} catch (error) {
			console.error("Error fetching data:", error.message);
			if (error.message === "Unauthorized") {
				navigate("/auth/login");
			}
		}
	};

	const getTemplateMasters = async (template, asset_id) => {
		try {
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-masters/${template._id}/leaf-group`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						asset_id,
					}),
				},
				navigate // Include navigate if needed for error handling
			);

			return data.data || []; // Ensure data is an array, handle null case
		} catch (error) {
			console.error("Error fetching data:", error.message);
			if (error.message === "Unauthorized") {
				navigate("/auth/login"); // Navigate to login if unauthorized
			}
			return []; // Handle error gracefully, return empty array or default value
		}
	};
	const getAssetMasters = async (asset_id) => {
		try {
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-masters/${asset_id}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate
			);

			setAssetMasters(data.data || []);
		} catch (error) {
			console.error("Error fetching asset masters:", error.message);
			if (error.message === "Unauthorized") {
				navigate("/auth/login");
			}
		}
	};
	const handleInputChange = (e) => {
		const { name, value, type, files } = e.target;
		setFormValues((prevValues) => ({
			...prevValues,
			[name]: type === "file" ? files[0] : value,
		}));
	};

	const handleSelectChange = (templateId, masterId, value, text) => {
		setSelectedValues((prevValues) => ({
			...prevValues,
			[templateId]: {
				...prevValues[templateId],
				[masterId]: { value, text },
			},
		}));
	};

	const handleAttributeChange = (templateId, attributeId, value) => {
		setSelectedValues((prevValues) => ({
			...prevValues,
			[templateId]: {
				...prevValues[templateId],
				[attributeId]: { value },
			},
		}));
	};

	const validateRow = (templateId, assetTemplate) => {
		const selected = selectedValues[templateId] || {};
		let isValid = true;
		const newErrors = {};

		// Check all templateMasters fields
		if (templateMasters[templateId]) {
			templateMasters[templateId].forEach((templateMaster) => {
				if (
					!selected[templateMaster.master_id] ||
					!selected[templateMaster.master_id].value
				) {
					isValid = false;
					newErrors[
						templateMaster.master_id
					] = `${templateMaster.master_name} is required`;
				}
			});
		}

		// Check all attribute fields
		assetTemplate.attributes.forEach((attribute) => {
			if (!selected[attribute._id] || !selected[attribute._id].value) {
				isValid = false;
				newErrors[attribute._id] = `${attribute.display_name} is required`;
			}
		});

		if (!isValid) {
			setErrors((prevErrors) => ({
				...prevErrors,
				[templateId]: {
					...prevErrors[templateId],
					...newErrors,
					general: "",
				},
			}));
		} else {
			setErrors((prevErrors) => ({
				...prevErrors,
				[templateId]: {},
			}));
		}

		return isValid;
	};

	// const handleAddClick = (templateId, assetTemplate) => {
	// 	const currentRows = rows[templateId] || [];

	// 	if (currentRows.length < parseInt(assetTemplate.rowlimit)) {
	// 		if (validateRow(templateId, assetTemplate)) {
	// 			setRows((prevRows) => ({
	// 				...prevRows,
	// 				[templateId]: [...currentRows, selectedValues[templateId]],
	// 			}));

	// 			setSelectedValues((prevValues) => ({
	// 				...prevValues,
	// 				[templateId]: {},
	// 			}));

	// 			resetFormFields(templateId);
	// 		}
	// 	} else {
	// 		toast.error(`Row limit of ${assetTemplate.rowlimit} reached `);
	// 	}
	// };
	const handleAddClick = (templateId, assetTemplate) => {
		const currentRows = rows[templateId] || [];

		const firstTemplateMasterId = templateMasters[templateId]?.[0]?.master_id;
		const selectedFirstDropdownValue = selectedValues[templateId]?.[firstTemplateMasterId]?.value;

		const duplicateFound = currentRows.some(
			(row) => row?.[firstTemplateMasterId]?.value === selectedFirstDropdownValue
		);

		if (duplicateFound) {
			setErrors((prevErrors) => ({
				...prevErrors,
				[templateId]: {
					...(prevErrors[templateId] || {}),
					[firstTemplateMasterId]: "This value is already taken.",
				},
			}));
			return;
		}

		if (currentRows.length < parseInt(assetTemplate.rowlimit)) {
			if (validateRow(templateId, assetTemplate)) {
				setRows((prevRows) => ({
					...prevRows,
					[templateId]: [...currentRows, selectedValues[templateId]],
				}));

				setSelectedValues((prevValues) => ({
					...prevValues,
					[templateId]: {},
				}));

				resetFormFields(templateId);

				// clear error after successful add
				setErrors((prevErrors) => ({
					...prevErrors,
					[templateId]: {
						...(prevErrors[templateId] || {}),
						[firstTemplateMasterId]: undefined,
					},
				}));
			}
		} else {
			toast.error(`Row limit of ${assetTemplate.rowlimit} reached`);
		}
	};

	const resetFormFields = (templateId) => {
		const inputs = document.querySelectorAll(`.row-${templateId} input`);
		const selects = document.querySelectorAll(`.row-${templateId} select`);
		inputs.forEach((input) => (input.value = ""));
		selects.forEach((select) => (select.value = ""));
	};

	const handleDeleteClick = (e, templateId, rowIndex) => {
		e.preventDefault();
		setRows((prevRows) => ({
			...prevRows,
			[templateId]: prevRows[templateId].filter(
				(_, index) => index !== rowIndex
			),
		}));
	};
	const handleEditInputChange = (id, selectedOption, isDropdown = false) => {
		setEditRowValues((prevValues) => {
			const updatedValues = {
				...prevValues,
				[id]: {
					value: isDropdown ? selectedOption?.value || "" : selectedOption,
					// Only include the label if it's a dropdown; otherwise, omit it
					...(isDropdown && { label: selectedOption?.label || "" }),
				},
			};

			return updatedValues;
		});
	};

	// const handleEditInputChange = (id, selectedOption, isDropdown = false) => {
	//   setEditRowValues((prevValues) => {
	//     const updatedValues = {
	//       ...prevValues,
	//       [id]: {
	//         value: isDropdown ? selectedOption?.value || "" : selectedOption,
	//         label: isDropdown
	//           ? selectedOption?.label || ""
	//           : prevValues[id]?.label || "",
	//       },
	//     };

	//     return updatedValues;
	//   });
	// };

	// Handles the click to start editing a row
	const handleEditClick = (templateId, rowIndex, assetTemplate) => {
		console.log("ebntered")
		const row = rows[templateId][rowIndex];
		setEditRowTemplateId(templateId);
		setEditRowIndex(rowIndex);
		setEditRowValues(() => {
			const initialValues = {};

			// Process templateMasters for dropdowns
			templateMasters[templateId].forEach((templateMaster) => {
				if (row[templateMaster.master_id]) {
					initialValues[templateMaster.master_id] = {
						value: row[templateMaster.master_id].value,
						label: row[templateMaster.master_id].text || "", // Ensure text is used if available
					};
				}
			});

			// Process attributes for text inputs
			assetTemplate.attributes.forEach((attribute) => {
				if (row[attribute._id]) {
					initialValues[attribute._id] = {
						value: row[attribute._id].value,
						// label: row[attribute._id].text || row[attribute._id].label || "", // Use text or label if available
					};
				}
			});

			return initialValues;
		});
	};

	// const handleSaveClick = (templateId, e) => {
	//   e.preventDefault();

	//   // Update rows with edited values
	//   const updatedRows = rows[templateId].map((row, index) => {
	//     if (index === editRowIndex) {
	//       const updatedRow = { ...row };

	//       // Update each field with new values
	//       for (const key in editRowValues) {
	//         updatedRow[key] = {
	//           value: editRowValues[key].value,
	//           text: editRowValues[key].label, // Use 'text' instead of 'label'
	//         };
	//       }


	//       return updatedRow;
	//     }
	//     return row;
	//   });

	//   // Update state with modified rows
	//   setRows((prevRows) => ({
	//     ...prevRows,
	//     [templateId]: updatedRows,
	//   }));

	//   // Reset edit states after saving
	//   setEditRowTemplateId(null);
	//   setEditRowIndex(null);
	//   setEditRowValues({});
	// };
	// const handleSaveClick = (templateId, e) => {
	// 	e.preventDefault();

	// 	// Update rows with edited values
	// 	const updatedRows = rows[templateId].map((row, index) => {
	// 		if (index === editRowIndex) {
	// 			const updatedRow = { ...row };

	// 			// Update each field with new values
	// 			for (const key in editRowValues) {
	// 				const isDropdown = templateMasters[templateId].some(
	// 					(templateMaster) => templateMaster.master_id === key
	// 				);

	// 				updatedRow[key] = {
	// 					value: editRowValues[key].value,
	// 					...(isDropdown && { text: editRowValues[key].label }), // Set text only for dropdowns
	// 				};
	// 			}

	// 			return updatedRow;
	// 		}
	// 		return row;
	// 	});

	// 	// Update state with modified rows
	// 	setRows((prevRows) => ({
	// 		...prevRows,
	// 		[templateId]: updatedRows,
	// 	}));

	// 	// Reset edit states after saving
	// 	setEditRowTemplateId(null);
	// 	setEditRowIndex(null);
	// 	setEditRowValues({});
	// };
	const handleSaveClick = (templateId, e) => {
		e.preventDefault();

		const firstTemplateMasterId = templateMasters[templateId]?.[0]?.master_id;
		const editedFirstDropdownValue = editRowValues[firstTemplateMasterId]?.value;

		// check if that value exists in other rows
		const duplicateFound = rows[templateId].some((row, idx) => {
			return (
				idx !== editRowIndex &&
				row?.[firstTemplateMasterId]?.value === editedFirstDropdownValue
			);
		});

		if (duplicateFound) {
			setErrors((prevErrors) => ({
				...prevErrors,
				[templateId]: {
					...(prevErrors[templateId] || {}),
					[editRowIndex]: {
						...(prevErrors[templateId]?.[editRowIndex] || {}),
						[firstTemplateMasterId]: "This value is already taken.",
					},
				},
			}));
			return;
		}

		const updatedRows = rows[templateId].map((row, index) => {
			if (index === editRowIndex) {
				const updatedRow = { ...row };
				for (const key in editRowValues) {
					updatedRow[key] = {
						value: editRowValues[key].value,
						text: editRowValues[key].label,
					};
				}
				return updatedRow;
			}
			return row;
		});

		setRows((prevRows) => ({
			...prevRows,
			[templateId]: updatedRows,
		}));

		// clear error after save
		setErrors((prevErrors) => ({
			...prevErrors,
			[templateId]: {
				...(prevErrors[templateId] || {}),
				[editRowIndex]: {},
			},
		}));

		// Reset after saving
		setEditRowTemplateId(null);
		setEditRowIndex(null);
		setEditRowValues({});
	};


	const handleSubmit = async (e) => {
		setLoading(true);
		e.preventDefault();

		// Check for empty required fields
		const newErrors = {};
		assetAttributes.forEach((attribute) => {
			if (attribute.required && !formValues[attribute.field_name]) {
				newErrors[
					attribute.field_name
				] = `${attribute.display_name} is required.`;
			}
		});

		// Check if every table has at least one row
		let allTablesHaveRows = assetTemplates.every(
			(template) => rows[template._id] && rows[template._id].length > 0
		);

		if (!allTablesHaveRows) {
			seterrforsubmit(
				"Please add at least one row in each table before submitting."
			);
			return; // Exit early if not all tables have rows
		}

		// If there are errors, set the errors state and do not submit the form
		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors);
			return;
		}

		const equipmentData = {
			...formValues,
			asset_id: assetId,
			templates: rows,
		};
		console.log("data to be submitted", equipmentData);

		try {
			// const response =
			await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/update/${equipment_id}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(equipmentData),
				},
				navigate
			);

			// if (!response.ok) {
			//   throw new Error("Failed to submit the form.");
			// }

			// // Ensure the response is properly parsed and handled
			// const responseData = await response.json();

			toast.success("Updated successfully");

			setLoading(false);

			setTimeout(() => {
				navigate("/all_assets");
			}, 1000);
		} catch (error) {
			console.error("Error submitting form:", error.message);
			toast.error("Failed to submit the form. Please try again.");

			setLoading(false);
		}
	};

	// const renderFormField = (attribute) => {
	// 	return (
	// 		<div
	// 			key={attribute._id}
	// 			className="col d-flex flex-column addEuipment-form-col"
	// 		>
	// 			<label htmlFor={attribute.field_name} className="addEuipment-form-text">
	// 				{attribute.display_name}
	// 				<span style={{ color: "#dc3545" }}>{attribute.required && " *"}</span>
	// 			</label>
	// 			{attribute.field_type === "string" ||
	// 				attribute.field_type === "number" ? (
	// 				<input
	// 					type={attribute.field_type}
	// 					name={attribute.field_name}
	// 					id={attribute.field_name}
	// 					placeholder={`Enter the ${attribute.display_name.toLowerCase()}`}
	// 					onChange={handleInputChange}
	// 					value={formValues[attribute.field_name] || ""}
	// 				/>
	// 			) : attribute.field_type === "select" ? (
	// 				<select
	// 					name={attribute.field_name}
	// 					className="textarea"
	// 					id={attribute.field_name}
	// 					onChange={handleInputChange}
	// 					value={formValues[attribute.field_name] || ""}
	// 				>
	// 					<option value="">Select {attribute.display_name}</option>
	// 					{attribute.field_value.map((option, index) => (
	// 						<option key={index} value={option}>
	// 							{option}
	// 						</option>
	// 					))}
	// 				</select>
	// 			) : attribute.field_type === "date" ? (
	// 				<input
	// 					type="date"
	// 					name={attribute.field_name}
	// 					id={attribute.field_name}
	// 					onChange={handleInputChange}
	// 					value={formValues[attribute.field_name] || ""}
	// 				/>
	// 			) : attribute.field_type === "textarea" ? (
	// 				<textarea
	// 					name={attribute.field_name}
	// 					id={attribute.field_name}
	// 					placeholder={`Enter the ${attribute.display_name.toLowerCase()}`}
	// 					onChange={handleInputChange}
	// 					value={formValues[attribute.field_name] || ""}
	// 				/>
	// 			) : attribute.field_type === "file" ? (
	// 				<input
	// 					type="file"
	// 					name={attribute.field_name}
	// 					id={attribute.field_name}
	// 					onChange={handleInputChange}
	// 				/>
	// 			) : null}
	// 			{errors[attribute.field_name] && (
	// 				<div
	// 					className="error mt-2"
	// 					style={{ color: "#dc3545", marginLeft: "8px" }}
	// 				>
	// 					{errors[attribute.field_name]}
	// 				</div>
	// 			)}
	// 		</div>
	// 	);
	// };


	const renderFormField = (attribute) => {
		return (
			<div
				key={attribute._id}
				className="col d-flex flex-column addEuipment-form-col"
			>
				<label htmlFor={attribute.field_name} className="addEuipment-form-text">
					{attribute.display_name}
					<span style={{ color: "#dc3545" }}>{attribute.required && " *"}</span>
				</label>

				{attribute.field_type === "string" ? (
					<input
						type="text"
						name={attribute.field_name}
						id={attribute.field_name}
						className="form-control"
						placeholder={`Enter the ${attribute.display_name.toLowerCase()}`}
						onChange={handleInputChange}
						value={formValues[attribute.field_name] || ""}
					/>
				) : attribute.field_type === "number" ? (
					<input
						type="number"
						name={attribute.field_name}
						id={attribute.field_name}
						className="form-control"
						placeholder={`Enter the ${attribute.display_name.toLowerCase()}`}
						onChange={handleInputChange}
						value={formValues[attribute.field_name] || ""}
					/>
				) : attribute.field_type === "select" ? (
					<select
						name={attribute.field_name}
						id={attribute.field_name}
						className="form-select"
						onChange={handleInputChange}
						value={formValues[attribute.field_name] || ""}
					>
						<option value="" disabled hidden>
							Select {attribute.display_name}
						</option>
						{attribute.field_value?.map((option, index) => (
							<option key={index} value={option}>
								{option}
							</option>
						))}
					</select>
				) : attribute.field_type === "date" ? (
					<input
						type="date"
						name={attribute.field_name}
						id={attribute.field_name}
						className="form-control"
						onChange={handleInputChange}
						value={formValues[attribute.field_name] || ""}
					/>
				) : attribute.field_type === "textarea" ? (
					<textarea
						name={attribute.field_name}
						id={attribute.field_name}
						className="form-control"
						placeholder={`Enter the ${attribute.display_name.toLowerCase()}`}
						onChange={handleInputChange}
						value={formValues[attribute.field_name] || ""}
					/>
				) : attribute.field_type === "file" ? (
					<input
						type="file"
						name={attribute.field_name}
						id={attribute.field_name}
						className="form-control"
						onChange={handleInputChange}
					/>
				) : null}

				{errors[attribute.field_name] && (
					<div
						className="error mt-2"
						style={{ color: "#dc3545", marginLeft: "8px" }}
					>
						{errors[attribute.field_name]}
					</div>
				)}
			</div>
		);
	};



	const groupedItems = [];
	for (let i = 0; i < assetAttributes.length; i += 2) {
		groupedItems.push(assetAttributes.slice(i, i + 2));
	}
	const handleOpenuploadModal = (isOpen, templateId, templatename) => {
		setShowUploadModal(isOpen);
		setSelectedTemplateId(templateId);
		setSelectedTemplateName(templatename)// Store the template ID in state
	};
	const [selectedFile, setSelectedFile] = useState(null);
	const fileInputRef = useRef(null);
	const handleCloseUploadModal = () => {
		setErrorMessages("");
		setErrorrowMessages("");
		setShowUploadModal(false);
		if (fileInputRef.current) {
			fileInputRef.current.value = null; // Reset the file input
		}
		setSelectedFile(null); // Clear the selected file
	};

	const handleFileChange = (event) => {
		const file = event.target.files[0];
		setSelectedFile(file); // Store the selected file
	};
	const downloadExcel = async (selectedTemplateId) => {
		setLoading(true);
		const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/download-empty-sheet/${selectedTemplateId}?asset_id=${assetId}`;


		try {
			const response = await fetchWrapper(
				url,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
				},
				navigate,
				true
			); // Pass rawResponse as true to get the raw response

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const blob = await response.blob(); // Get the blob from the response
			const downloadUrl = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = downloadUrl;
			// a.download = `master-${masterNamePlural}.xlsx`;
			a.download = `template_${selectedTemplateName}.xlsx`; // Specify the file name here
			document.body.appendChild(a);
			a.click();
			a.remove();

			setLoading(false);
			toast.success(`Download Excel Successful`);
		} catch (error) {
			setLoading(false);
			console.error(`Error downloading Excel:`, error);
			toast.error(`Failed to download Excel: ${error.message}`);
		}
	};
	// const uploadExcel = async (event, selectedTemplateId) => {
	//   event.preventDefault();

	//   if (!selectedFile) {
	//     toast.error("Please select a file before uploading.");
	//     return;
	//   }

	//   const reader = new FileReader();
	//   reader.onload = async (e) => {
	//     try {
	//       const data = new Uint8Array(e.target.result);
	//       const workbook = XLSX.read(data, { type: 'array' });
	//       const sheetName = workbook.SheetNames[0];
	//       const worksheet = workbook.Sheets[sheetName];
	//       const jsonData = XLSX.utils.sheet_to_json(worksheet);

	//       // Check the row limit first
	//       const currentRows = rows[selectedTemplateId] || [];
	//       const assetTemplate = assetTemplates.find(t => t._id === selectedTemplateId);
	//       const rowLimit = parseInt(assetTemplate.rowlimit);
	//       const remainingSpace = rowLimit - currentRows.length;

	//       if (jsonData.length > remainingSpace) {
	//         toast.error(`Currently, only ${remainingSpace} row can be added since the row limit is ${rowLimit}, but the Excel file has ${jsonData.length} rows .`);
	//         setErrorrowMessages(`Currently, only ${remainingSpace} row can be added since the row limit is ${rowLimit}, but the Excel file has ${jsonData.length} rows .`);
	//         return; // Stop further processing since the limit is exceeded
	//       }

	//       // Validate the data
	//       const validatedData = validateExcelData(jsonData, selectedTemplateId);

	//       if (validatedData.length > 0) {
	//         // Add the validated data to the rows state
	//         setRows(prevRows => ({
	//           ...prevRows,
	//           [selectedTemplateId]: [
	//             ...currentRows,
	//             ...validatedData
	//           ]
	//         }));

	//         toast.success(`Successfully added ${validatedData.length} rows to the template.`);

	//         handleCloseUploadModal(); // Close the modal and reset the file input
	//       } else {
	//         toast.error("No valid data found in the Excel file.");
	//       }
	//     } catch (error) {
	//       console.error("Error processing Excel file:", error);
	//       toast.error("Error processing Excel file. Please check the file format and try again.");
	//     }
	//   };

	//   reader.readAsArrayBuffer(selectedFile);
	// };

	// const validateExcelData = (jsonData, selectedTemplateId) => {
	//   const template = assetTemplates.find(t => t._id === selectedTemplateId);
	//   if (!template) {
	//     console.error("Template not found");
	//     return [];
	//   }

	//   const rowLimit = parseInt(template.rowlimit);
	//   const currentRows = rows[selectedTemplateId] || [];
	//   const remainingSpace = rowLimit - currentRows.length;

	//   if (!jsonData || jsonData.length === 0) {

	//     return [];
	//   }

	//   let hasError = false;
	//   const newErrorMessages = []; // Array to store error messages
	//   const validData = jsonData.map((row, index) => {
	//     const validRow = {};
	//     let isValid = true;

	//     templateMasters[selectedTemplateId]?.forEach((master) => {
	//       const valueFromExcel = row[master.heading_name] || row[master.master_name];
	//       const dropdownOptions = assetMasters
	//         .filter(
	//           (asset_master) => asset_master.template_master_id?.master_id === master.master_id
	//         )
	//         .map((asset_master) => ({
	//           value: asset_master._id,
	//           text: asset_master.document_code,
	//         }));

	//       const matchedOption = dropdownOptions.find(option => option.text === valueFromExcel);

	//       if (matchedOption) {
	//         validRow[master.master_id] = {
	//           value: matchedOption.value,  // Set the correct ID
	//           text: matchedOption.text,    // Set the display text
	//         };
	//       } else {
	//         const errorMessage = `Invalid value '${valueFromExcel}' for dropdown '${master.master_name}' in row ${index + 1}`;
	//         newErrorMessages.push(errorMessage); // Collect error messages
	//         isValid = false;
	//       }
	//     });

	//     template.attributes.forEach((attr) => {
	//       const value = row[attr.display_name];
	//       if (value) {
	//         validRow[attr._id] = { value }; // Only set value for attributes
	//       }
	//     });

	//     if (!isValid) {
	//       hasError = true;
	//       return null;
	//     }

	//     return Object.keys(validRow).length > 0 ? validRow : null;
	//   });

	//   if (hasError) {
	//     setErrorMessages(newErrorMessages); // Update state with error messages
	//     toast.error("Errors found in the uploaded file. Please fix them and try again.");
	//     return [];
	//   }

	//   return validData.slice(0, remainingSpace);
	// };

	// const uploadExcel = async (event, selectedTemplateId) => {
	// 	event.preventDefault();

	// 	if (!selectedFile) {
	// 		toast.error("Please select a file before uploading.");
	// 		return;
	// 	}

	// 	const reader = new FileReader();
	// 	reader.onload = async (e) => {
	// 		try {
	// 			const workbook = new ExcelJS.Workbook();
	// 			const data = e.target.result;
	// 			await workbook.xlsx.load(data);

	// 			// Grab the first worksheet
	// 			const worksheet = workbook.worksheets[0];

	// 			// Convert the worksheet to JSON data
	// 			const jsonData = [];
	// 			worksheet.eachRow({ includeEmpty: false }, (row, rowIndex) => {
	// 				// Skip the first row (header row)
	// 				if (rowIndex === 1) return;

	// 				const rowData = {};
	// 				worksheet.getRow(1).eachCell((cell, colIndex) => {
	// 					rowData[cell.value] = row.getCell(colIndex).value;
	// 				});

	// 				jsonData.push(rowData);
	// 			});

	// 			// Check the row limit first
	// 			const currentRows = rows[selectedTemplateId] || [];
	// 			const assetTemplate = assetTemplates.find(t => t._id === selectedTemplateId);
	// 			const rowLimit = parseInt(assetTemplate.rowlimit);
	// 			const remainingSpace = rowLimit - currentRows.length;

	// 			if (jsonData.length > remainingSpace) {
	// 				toast.error(`Currently, only ${remainingSpace} row can be added since the row limit is ${rowLimit}, but the Excel file has ${jsonData.length} rows.`);
	// 				setErrorrowMessages(`Currently, only ${remainingSpace} row can be added since the row limit is ${rowLimit}, but the Excel file has ${jsonData.length} rows.`);
	// 				return; // Stop further processing since the limit is exceeded
	// 			}

	// 			// Validate the data
	// 			const validatedData = validateExcelData(jsonData, selectedTemplateId);

	// 			if (validatedData.length > 0) {
	// 				// Add the validated data to the rows state
	// 				setRows(prevRows => ({
	// 					...prevRows,
	// 					[selectedTemplateId]: [
	// 						...currentRows,
	// 						...validatedData
	// 					]
	// 				}));

	// 				toast.success(`Successfully added ${validatedData.length} rows to the template.`);
	// 				handleCloseUploadModal(); // Close the modal and reset the file input
	// 			} else {
	// 				toast.error("No valid data found in the Excel file.");
	// 			}
	// 		} catch (error) {
	// 			console.error("Error processing Excel file:", error);
	// 			toast.error("Error processing Excel file. Please check the file format and try again.");
	// 		}
	// 	};

	// 	reader.readAsArrayBuffer(selectedFile);
	// };
	const uploadExcel = async (event, selectedTemplateId) => {

		event.preventDefault();

		if (!selectedFile) {
			toast.error("Please select a file before uploading.");
			return;
		}

		const reader = new FileReader();
		reader.onload = async (e) => {
			try {
				const workbook = new ExcelJS.Workbook();
				const data = e.target.result;
				await workbook.xlsx.load(data);

				const worksheet = workbook.worksheets[0];
				const jsonData = [];

				// get first column header name
				const firstColumnHeader = worksheet.getRow(1).getCell(1).value;

				worksheet.eachRow({ includeEmpty: false }, (row, rowIndex) => {
					if (rowIndex === 1) return;

					const rowData = {};
					worksheet.getRow(1).eachCell((cell, colIndex) => {
						rowData[cell.value] = row.getCell(colIndex).value;
					});

					jsonData.push(rowData);
				});

				const currentRows = rows[selectedTemplateId] || [];
				const assetTemplate = assetTemplates.find((t) => t._id === selectedTemplateId);
				const rowLimit = parseInt(assetTemplate.rowlimit);
				const remainingSpace = rowLimit - currentRows.length;

				if (jsonData.length > remainingSpace) {
					const errorMsg = `Currently, only ${remainingSpace} row can be added since the row limit is ${rowLimit}, but the Excel file has ${jsonData.length} rows.`;
					toast.error(errorMsg);
					setErrorrowMessages(errorMsg);

					return;
				}

				// get existing second column values from current rows
				const existingFirstColumnValues = currentRows.map((row) => {
					const keys = Object.keys(row);
					// assuming the second key is the second column:
					return row[keys[0]]?.value;
				});

				// check if any uploaded row's first column is duplicated
				const duplicateFound = jsonData.some((row) => {
					const newValue = row[firstColumnHeader];
					return existingFirstColumnValues.includes(newValue);
				});

				if (duplicateFound) {
					const msg = `Duplicate value found in the first column across existing rows.`;
					toast.error(msg);
					setErrorrowMessages(msg);
					return;
				}

				// optionally, you can also check for duplicates within the uploaded file itself:
				const uploadedFirstColumnValues = jsonData.map((row) => row[firstColumnHeader]);
				const hasInternalDuplicates =
					new Set(uploadedFirstColumnValues).size !== uploadedFirstColumnValues.length;

				if (hasInternalDuplicates) {
					const msg = `The Excel file has duplicate values in the first column.`;
					toast.error(msg);
					setErrorrowMessages(msg);
					return;
				}

				// Validate the data
				const validatedData = validateExcelData(jsonData, selectedTemplateId);

				if (validatedData.length > 0) {
					setRows((prevRows) => ({
						...prevRows,
						[selectedTemplateId]: [...currentRows, ...validatedData],
					}));

					toast.success(`Successfully added ${validatedData.length} rows to the template.`);
					handleCloseUploadModal();
				} else {
					toast.error("No valid data found in the Excel file.");
				}
			} catch (error) {
				console.error("Error processing Excel file:", error);
				toast.error("Error processing Excel file. Please check the file format and try again.");
			}
		};

		reader.readAsArrayBuffer(selectedFile);
	};


	const validateExcelData = (jsonData, selectedTemplateId) => {
		const template = assetTemplates.find(t => t._id === selectedTemplateId);
		if (!template) {
			console.error("Template not found");
			return [];
		}

		const rowLimit = parseInt(template.rowlimit);
		const currentRows = rows[selectedTemplateId] || [];
		const remainingSpace = rowLimit - currentRows.length;

		if (!jsonData || jsonData.length === 0) {
			return [];
		}

		let hasError = false;
		const newErrorMessages = []; // Array to store error messages

		const validData = jsonData.map((row, index) => {
			const validRow = {};
			let isValid = true;

			// Validate dropdown fields
			templateMasters[selectedTemplateId]?.forEach((master) => {
				const valueFromExcel = row[master.heading_name] || row[master.master_name];
				const dropdownOptions = assetMasters
					.filter(
						(asset_master) => asset_master.template_master_id?.master_id === master.master_id
					)
					.map((asset_master) => ({
						value: asset_master._id,
						text: asset_master.document_code,
					}));

				const matchedOption = dropdownOptions.find(option => option.text === valueFromExcel);

				if (matchedOption) {
					validRow[master.master_id] = {
						value: matchedOption.value,  // Set the correct ID
						text: matchedOption.text,    // Set the display text
					};
				} else {

					const errorMessage = `Invalid value '${valueFromExcel}' for dropdown '${master.master_name}' in row ${index + 1}`;
					newErrorMessages.push(errorMessage); // Collect error messages
					isValid = false;
				}
			});

			// Validate attribute fields (now with empty check)
			template.attributes.forEach((attr) => {
				let value = row[attr.display_name];

				// Trim and ensure the value is a string if not null/undefined
				if (value !== null && value !== undefined) {
					value = value.toString().trim();
				}

				if (value === "" || value === null || value === undefined) {
					// Handle missing values
					const errorMessage = `Missing value for attribute '${attr.display_name}' in row ${index + 1}`;
					newErrorMessages.push(errorMessage);
					isValid = false;
				} else {
					if (attr.field_type === "number") {
						if (isNaN(Number(value))) {
							// Handle invalid number
							const errorMessage = `Invalid value '${value}' for attribute '${attr.display_name}' in row ${index + 1}`;
							newErrorMessages.push(errorMessage);
							isValid = false;
						} else {
							validRow[attr._id] = { value: Number(value) };
						}
					} else {
						validRow[attr._id] = { value: value };
					}
				}
			});

			// If row is not valid, skip adding it
			if (!isValid) {
				hasError = true;
				return null; // Skip invalid row
			}

			return Object.keys(validRow).length > 0 ? validRow : null;
		});

		// If there are errors, show a toast and return empty
		if (hasError) {
			setErrorMessages(newErrorMessages); // Update state with error messages
			toast.error("Errors found in the uploaded file. Please fix them and try again.");
			return [];
		}

		return validData.slice(0, remainingSpace);
	};




	const fetchMasterValues = async (masterId) => {
		try {
			const response = await fetch(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/get-masters`,
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ masterId }),
				}
			);
			console.log("response", response);
			if (!response.ok) throw new Error("Failed to fetch master values");
			const data = await response.json();
			return data || []; // return the array directly, no data.data
		} catch (error) {
			console.error("Error fetching master values:", error);
			return [];
		}
	};


	// useEffect(() => {
	// 	const loadAllMasterOptions = async () => {
	// 		let allOptions = [];

	// 		for (const attribute of assetTemplates) {
	// 			for (const attr of attribute.attributes) {
	// 				if (attr.master_id) {
	// 					const options = await fetchMasterValues(attr.master_id);
	// 					allOptions = options; // overwrite or combine, depending on logic
	// 					break; // if all master_ids return same options, no need to loop more
	// 				}
	// 			}
	// 		}
	// 		console.log("optionsss", allOptions)
	// 		setMasterOptions(allOptions); // save as array directly
	// 	};

	// 	loadAllMasterOptions();
	// }, [assetTemplates]);

	useEffect(() => {
		const loadAllMasterOptions = async () => {
			const newMap = {};

			for (const template of assetTemplates) {
				for (const attr of template.attributes) {
					if (attr.master_id && !newMap[attr.master_id]) {
						const options = await fetchMasterValues(attr.master_id);
						newMap[attr.master_id] = options;
					}
				}
			}

			setMasterOptionsMap(newMap);
		};

		loadAllMasterOptions();
	}, [assetTemplates]);



	return (
		<>
			{loading ? (
				<Loader />
			) : (
				<div className="container">
					<div className="pt-3 pb-0 d-flex justify-content-between">
						<div>
							<h5>Edit Equipment</h5>
							<nav
								className="breadcrumb-nav show-breadcrumb"
								aria-label="breadcrumb"
							>
								<ol className="breadcrumb template-breadcrumb">
									<li className="breadcrumb-item">
										<Link to="#">My Assets</Link>
									</li>
									<li className="breadcrumb-item">
										<Link to={"/all_assets"}>All Asset</Link>
									</li>
									<li className="breadcrumb-item active" aria-current="page">
										Edit Equipment
									</li>
								</ol>
							</nav>
						</div>
						<div className="dropdown">
							<select
								id="cars"
								disabled="true"
								style={{ height: "50px", width: "300px" }}
								className="select-unit textarea"
								onChange={(e) => handleAssetClassChange(e.target.value)}
								value={assetId} // Set value of select to assetId
							>
								<option value="">Select Asset Class</option>
								{assets.map((asset) => (
									<option key={asset._id} value={asset._id}>
										{asset.asset_name}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="addEuipment">
						<div>
							<div className="addEuipment-header">
								<h4>Edit Equipment</h4>
							</div>
							<form onSubmit={handleSubmit}>
								<div className="addEuipment-form">
									{groupedItems.map((group, index) => (
										<div className="row" key={index}>
											{group.map((attribute) => renderFormField(attribute))}
											{group.length === 1 && (
												<div className="col-md-6 d-flex flex-column addEuipment-form-col"></div>
											)}
										</div>
									))}

									{assetTemplates &&
										assetTemplates.map((assetTemplate, i) => (
											<div className="row mb-4" key={i}>
												<div
													className="d-flex justify-content-between align-items-center col-sm-12 mb-n2 mb-2"
												>
													<div>{assetTemplate.template_code} Template</div>
													<div>
														<button
															type="button"
															id="openPopup"
															className="btn-bg text-capitalize"
															onClick={() => {
																handleOpenuploadModal(true, assetTemplate._id, assetTemplate.template_code); // Pass the assetTemplate._id here
															}}
														>
															Bulk Upload
														</button>
													</div>
												</div>
												<div className="table-responsive">
													<table className="table align-middle table-text">
														<thead className="table-head align-middle">
															<tr>
																<th className="text-center">#</th>
																{templateMasters[assetTemplate._id] &&
																	templateMasters[assetTemplate._id].map(
																		(templateMaster, j) => (
																			<th className="text-uppercase" key={j}>
																				{/* {templateMaster.heading_name
                                          ? templateMaster.heading_name
                                          : templateMaster.master_name} */}
																				{templateMaster.heading_name ? templateMaster.heading_name : templateMaster.master_name}
																			</th>
																		)
																	)}
																{assetTemplate.attributes &&
																	assetTemplate.attributes.map(
																		(attribute, k) => (
																			<th className="text-uppercase" key={k}>
																				{attribute.display_name}
																			</th>
																		)
																	)}
																<th className="text-center text-uppercase">
																	Action
																</th>
															</tr>
														</thead>
														<tbody>
															{errors[assetTemplate._id] &&
																errors[assetTemplate._id].general && (
																	<tr>
																		<td colSpan="100%" className="text-center">
																			<div
																				className="error"
																				style={{ color: "#dc3545" }}
																			>
																				{errors[assetTemplate._id].general}
																			</div>
																		</td>
																	</tr>
																)}
															<tr className={`row-${assetTemplate._id}`}>
																<td className="text-center">#</td>
																{templateMasters[assetTemplate._id] &&
																	templateMasters[assetTemplate._id].map(
																		(templateMaster, j) => (
																			<td key={j}>
																				<div className="dropdown">
																					<Select
																						id="asset_class"
																						value={
																							selectedValues[
																								assetTemplate._id
																							] &&
																								selectedValues[assetTemplate._id][
																								templateMaster?.master_id
																								]
																								? {
																									value:
																										selectedValues[
																											assetTemplate._id
																										][
																											templateMaster
																												?.master_id
																										].value,
																									label:
																										selectedValues[
																											assetTemplate._id
																										][
																											templateMaster
																												?.master_id
																										].text,
																								}
																								: null
																						}
																						onChange={(selectedOption) =>
																							handleSelectChange(
																								assetTemplate._id,
																								templateMaster?.master_id,
																								selectedOption
																									? selectedOption.value
																									: "",
																								selectedOption
																									? selectedOption.label
																									: ""
																							)
																						}
																						styles={customStyles}
																						options={assetMasters
																							.filter(
																								(asset_master) =>
																									asset_master
																										.template_master_id
																										?.master_id ===
																									templateMaster?.master_id
																							)
																							.map((asset_master) => ({
																								value: asset_master._id,
																								label:
																									asset_master.document_code,
																							}))}
																						placeholder="Select One"
																						isClearable={true}
																						isSearchable={true}
																						menuPortalTarget={document.body}
																						menuPosition="fixed"
																					/>

																					{errors[assetTemplate._id] &&
																						errors[assetTemplate._id][
																						templateMaster?.master_id
																						] && (
																							<div
																								className="error"
																								style={{ color: "#dc3545" }}
																							>
																								{
																									errors[assetTemplate._id][
																									templateMaster?.master_id
																									]
																								}
																							</div>
																						)}
																				</div>
																			</td>
																		)
																	)}
																{/* {assetTemplate.attributes.map(
																	(attribute, k) => (
																		<td key={k}>
																			<input
																				type="text"
																				placeholder={
																					"Enter " + attribute.display_name
																				}
																				onChange={(e) =>
																					handleAttributeChange(
																						assetTemplate._id,
																						attribute._id,
																						e.target.value
																					)
																				}
																			/>
																			{errors[assetTemplate._id] &&
																				errors[assetTemplate._id][
																				attribute._id
																				] && (
																					<div
																						className="error"
																						style={{ color: "#dc3545" }}
																					>
																						{
																							errors[assetTemplate._id][
																							attribute._id
																							]
																						}
																					</div>
																				)}
																		</td>
																	)
																)} */}

																{/* {assetTemplate.attributes.map((attribute, k) => {
																	const hasDropdownOptions =
																		Array.isArray(attribute.field_value) &&
																		attribute.field_value.length > 0 &&
																		attribute.field_value.some((val) => val.trim() !== "");

																	return (
																		<td key={k}>
																			{hasDropdownOptions ? (
																				<select
																					onChange={(e) =>
																						handleAttributeChange(
																							assetTemplate._id,
																							attribute._id,
																							e.target.value
																						)
																					}
																				>
																					<option value="">Select {attribute.display_name}</option>
																					{attribute.field_value.map((option, index) => (
																						<option key={index} value={option}>
																							{option}
																						</option>
																					))}
																				</select>
																			) : (
																				<input
																					type="text"
																					placeholder={`Enter ${attribute.display_name}`}
																					onChange={(e) =>
																						handleAttributeChange(
																							assetTemplate._id,
																							attribute._id,
																							e.target.value
																						)
																					}
																				/>
																			)}

																			{errors[assetTemplate._id] && errors[assetTemplate._id][attribute._id] && (
																				<div className="error" style={{ color: "#dc3545" }}>
																					{errors[assetTemplate._id][attribute._id]}
																				</div>
																			)}
																		</td>
																	);
																})} */}

																{/* {assetTemplate.attributes.map((attribute, k) => {
																	const { master_id, field_value, field_type, display_name, _id: attributeId } = attribute;

																	const hasFieldValues = Array.isArray(field_value) && field_value.length > 0;
																	const hasMaster = master_id && masterOptionsMap[master_id];

																	const options = hasMaster
																		? masterOptionsMap[master_id] || []
																		: hasFieldValues
																			? field_value
																			: [];

																	const isDropdown =
																		field_type === "list" || field_type === "select" || hasMaster || hasFieldValues;

																	return (
																		<td key={k}>
																			{isDropdown ? (
																				// <select
																				// 	onChange={(e) => {
																				// 		const selectedValue = e.target.value;

																				// 		const selectedOption = options.find((option) => {
																				// 			const optVal = typeof option === "object" ? String(option._id) : String(option);
																				// 			return optVal === selectedValue;
																				// 		});

																				// 		const value =
																				// 			typeof selectedOption === "object" ? selectedOption._id : selectedOption;

																				// 		handleAttributeChange(assetTemplate._id, attributeId, value);
																				// 	}}
																				// >

																				<select
																					onChange={(e) => {
																						const selectedValue = e.target.value;

																						const selectedOption = options.find((option) => {
																							const optVal = typeof option === "object" ? String(option._id) : String(option);
																							return optVal === selectedValue;
																						});

																						const value =
																							typeof selectedOption === "object"
																								? selectedOption.master_column_name || "Unknown"
																								: selectedOption;

																						handleAttributeChange(assetTemplate._id, attributeId, value);
																					}}
																				>
																					<option value="">Select {display_name}</option>
																					{options.map((option, index) => {
																						const value = typeof option === "object" ? option._id : option;
																						const label =
																							typeof option === "object"
																								? option.component_code ||
																								option.plant_name ||
																								option.label ||
																								"Unknown"
																								: option;

																						return (
																							<option key={index} value={value}>
																								{label}
																							</option>
																						);
																					})}
																				</select>
																			) : (
																				<input
																					type="text"
																					placeholder={`Enter ${display_name}`}
																					onChange={(e) =>
																						handleAttributeChange(assetTemplate._id, attributeId, e.target.value)
																					}
																				/>
																			)}

																			{errors[assetTemplate._id] && errors[assetTemplate._id][attributeId] && (
																				<div className="error" style={{ color: "#dc3545" }}>
																					{errors[assetTemplate._id][attributeId]}
																				</div>
																			)}
																		</td>
																	);
																})} */}

																{/* working code  */}
																{/* {assetTemplate.attributes.map((attribute, k) => {
																	const { master_id, field_value, field_type, display_name, _id: attributeId } = attribute;

																	const hasFieldValues = Array.isArray(field_value) && field_value.length > 0;
																	const hasMaster = master_id && masterOptionsMap[master_id];

																	const options = hasMaster
																		? masterOptionsMap[master_id] || []
																		: hasFieldValues
																			? field_value
																			: [];

																	const isDropdown =
																		field_type === "list" || field_type === "select" || hasMaster || hasFieldValues;

																	return (
																		<td key={k}>
																			{isDropdown ? (
																				// <select
																				// 	onChange={(e) => {
																				// 		const selectedValue = e.target.value;

																				// 		const selectedOption = options.find((option) => {
																				// 			const optVal = typeof option === "object" ? String(option._id) : String(option);
																				// 			return optVal === selectedValue;
																				// 		});

																				// 		const value =
																				// 			typeof selectedOption === "object" ? selectedOption._id : selectedOption;

																				// 		handleAttributeChange(assetTemplate._id, attributeId, value);
																				// 	}}
																				// >

																				<select
																					onChange={(e) => {
																						const selectedValue = e.target.value;

																						const selectedOption = options.find((option) => {
																							const optVal = typeof option === "object" ? String(option._id) : String(option);
																							return optVal === selectedValue;
																						});

																						const value =
																							typeof selectedOption === "object"
																								? selectedOption.master_column_name || "Unknown"
																								: selectedOption;

																						handleAttributeChange(assetTemplate._id, attributeId, value);
																					}}
																				>
																					<option value="">Select {display_name}</option>
																					{options.map((option, index) => {
																						const value = typeof option === "object" ? option._id : option;
																						const label =
																							typeof option === "object"
																								? option.master_column_name ||

																								"Unknown"
																								: option;

																						return (
																							<option key={index} value={value}>
																								{label}
																							</option>
																						);
																					})}
																				</select>
																			) : (
																				<input
																					type="text"
																					placeholder={`Enter ${display_name}`}
																					onChange={(e) =>
																						handleAttributeChange(assetTemplate._id, attributeId, e.target.value)
																					}
																				/>
																			)}

																			{errors[assetTemplate._id] && errors[assetTemplate._id][attributeId] && (
																				<div className="error" style={{ color: "#dc3545" }}>
																					{errors[assetTemplate._id][attributeId]}
																				</div>
																			)}
																		</td>
																	);
																})} */}


																{assetTemplate.attributes.map((attribute, k) => {
																	const {
																		master_id,
																		field_value,
																		field_type,
																		display_name,
																		_id: attributeId
																	} = attribute;

																	const hasFieldValues = Array.isArray(field_value) && field_value.length > 0;
																	const hasMaster = master_id && masterOptionsMap[master_id];

																	const options = hasMaster
																		? masterOptionsMap[master_id] || []
																		: hasFieldValues
																			? field_value
																			: [];

																	const isDropdown =
																		(field_type === "list" || field_type === "select") ||
																		(hasMaster || hasFieldValues);

																	// Treat these as text inputs
																	const treatAsTextInput =
																		field_type === "string" || field_type === "date" || field_type === "textarea" || field_type === "number";

																	return (
																		<td key={k}>
																			{isDropdown && !treatAsTextInput ? (
																				<select
																					onChange={(e) => {
																						const selectedValue = e.target.value;

																						const selectedOption = options.find((option) => {
																							const optVal = typeof option === "object" ? String(option._id) : String(option);
																							return optVal === selectedValue;
																						});

																						const value =
																							typeof selectedOption === "object"
																								? selectedOption.master_column_name || "Unknown"
																								: selectedOption;

																						handleAttributeChange(assetTemplate._id, attributeId, value);
																					}}
																				>
																					<option value="">Select {display_name}</option>
																					{options.map((option, index) => {
																						const value = typeof option === "object" ? option._id : option;
																						const label =
																							typeof option === "object"
																								? option.master_column_name || "Unknown"
																								: option;

																						return (
																							<option key={index} value={value}>
																								{label}
																							</option>
																						);
																					})}
																				</select>
																			) : (
																				<input
																					type="text"
																					placeholder={`Enter ${display_name}`}
																					onChange={(e) =>
																						handleAttributeChange(assetTemplate._id, attributeId, e.target.value)
																					}
																				/>
																			)}

																			{/* Error display */}
																			{errors[assetTemplate._id] && errors[assetTemplate._id][attributeId] && (
																				<div className="error" style={{ color: "#dc3545" }}>
																					{errors[assetTemplate._id][attributeId]}
																				</div>
																			)}
																		</td>
																	);
																})}








																<td className="text-center">
																	<button
																		style={{ width: "150px" }}
																		type="button"
																		onClick={() =>
																			handleAddClick(
																				assetTemplate._id,
																				assetTemplate
																			)
																		}
																		className="addEuipment-update-btn"
																	>
																		<span className="plus-icon">
																			<img src={plus1} alt="Plus Icon" />
																		</span>
																		Add
																	</button>
																</td>
															</tr>

															{rows[assetTemplate._id] &&
																rows[assetTemplate._id].map((row, rowIndex) => (
																	<tr key={rowIndex}>
																		<td>{rowIndex + 1}</td>
																		{templateMasters[assetTemplate._id] &&
																			templateMasters[assetTemplate._id].map(
																				(templateMaster, colIndex) => (
																					<td key={colIndex}>
																						{editRowTemplateId ===
																							assetTemplate._id &&
																							editRowIndex === rowIndex ? (
																							<Select
																								id={`edit_asset_class_${rowIndex}`}
																								value={
																									editRowValues[
																										templateMaster.master_id
																									]
																										? {
																											value:
																												editRowValues[
																													templateMaster
																														.master_id
																												].value,
																											label:
																												editRowValues[
																													templateMaster
																														.master_id
																												].label,
																										}
																										: null
																								}
																								onChange={(selectedOption) =>
																									handleEditInputChange(
																										templateMaster.master_id,
																										selectedOption,
																										true
																									)
																								}
																								styles={customStyles}
																								options={assetMasters
																									.filter(
																										(asset_master) =>
																											asset_master
																												.template_master_id
																												?.master_id ===
																											templateMaster?.master_id
																									)
																									.map((asset_master) => ({
																										value: asset_master._id,
																										label:
																											asset_master.document_code,
																									}))}
																								placeholder="Select One"
																								isClearable={true}
																								isSearchable={true}
																								menuPortalTarget={document.body}
																								menuPosition="fixed"
																							/>
																						) : (
																							row[templateMaster.master_id]
																								?.text ||
																							row[templateMaster.master_id]
																								?.value
																						)}
																						{errors[assetTemplate._id] &&
																							errors[assetTemplate._id][rowIndex] &&
																							errors[assetTemplate._id][rowIndex][templateMaster.master_id] && (
																								<div
																									className="error"
																									style={{ color: "#dc3545" }}
																								>
																									{errors[assetTemplate._id][rowIndex][templateMaster.master_id]}
																								</div>
																							)}
																					</td>
																				)
																			)}

																		{assetTemplate.attributes.map((attribute, colIndex) => {
																			const {
																				master_id,
																				field_value,
																				field_type,
																				display_name,
																				_id: attributeId
																			} = attribute;

																			const hasFieldValues = Array.isArray(field_value) && field_value.length > 0;
																			const hasMaster = master_id && masterOptionsMap[master_id];

																			const options = hasMaster
																				? masterOptionsMap[master_id]
																				: hasFieldValues
																					? field_value
																					: [];

																			const isDropdown =
																				field_type === "list" ||
																				field_type === "select" ||
																				hasMaster ||
																				hasFieldValues;

																			const treatAsTextInput =
																				field_type === "string" ||
																				field_type === "date" ||
																				field_type === "textarea" || field_type === "number";

																			const storedValue = editRowValues[attributeId]?.value || "";

																			const selectedOption = options.find((opt) =>
																				typeof opt === "object"
																					? (opt.master_column_name || opt.document_code || "Unknown") === storedValue
																					: opt === storedValue
																			);

																			const dropdownValue = selectedOption
																				? {
																					value: typeof selectedOption === "object"
																						? selectedOption._id
																						: selectedOption,
																					label: typeof selectedOption === "object"
																						? selectedOption.master_column_name || selectedOption.document_code || "Unknown"
																						: selectedOption
																				}
																				: null;

																			return (
																				<td key={colIndex}>
																					{editRowTemplateId === assetTemplate._id &&
																						editRowIndex === rowIndex ? (
																						isDropdown && !treatAsTextInput ? (
																							<Select
																								value={dropdownValue}
																								onChange={(selectedOption) =>
																									handleEditInputChange1(attributeId, selectedOption, true)
																								}
																								options={options.map((opt) =>
																									typeof opt === "object"
																										? {
																											value: opt._id,
																											label: opt.master_column_name || opt.document_code || "Unknown"
																										}
																										: { value: opt, label: opt }
																								)}
																								styles={customStyles}
																								placeholder={`Select ${display_name}`}
																								isClearable={true}
																								isSearchable={true}
																								menuPortalTarget={document.body}
																								menuPosition="fixed"
																							/>
																						) : (
																							<input
																								type="text"
																								value={editRowValues[attributeId]?.value || ""}
																								onChange={(e) =>
																									handleEditInputChange1(attributeId, e.target.value, false)
																								}
																								placeholder={`Enter ${display_name}`}
																							/>
																						)
																					) : (
																						row[attributeId]?.value || ""
																					)}

																					{/* Error display */}
																					{errors[assetTemplate._id] &&
																						errors[assetTemplate._id][attributeId] && (
																							<div className="error" style={{ color: "#dc3545" }}>
																								{errors[assetTemplate._id][attributeId]}
																							</div>
																						)}
																				</td>
																			);
																		})}


																		<td className="text-center">
																			{editRowTemplateId ===
																				assetTemplate._id &&
																				editRowIndex === rowIndex ? (
																				<button
																					style={{ width: "150px" }}
																					type="button"
																					onClick={(e) =>
																						handleSaveClick(
																							assetTemplate._id,
																							e
																						)
																					}
																					className="addEuipment-update-btn"
																				>
																					Save
																				</button>
																			) : (
																				<>
																					<button
																						style={{
																							border: "none",
																							background: "transparent",
																						}}
																						className="align-content-center me-3 mt-1"
																						onClick={() =>
																							handleEditClick(
																								assetTemplate._id,
																								rowIndex,
																								assetTemplate
																							)
																						}
																					>
																						<img
																							style={{ width: "25px" }}
																							src={edit}
																							alt="edit"
																						/>
																					</button>
																					<button
																						style={{
																							border: "none",
																							background: "transparent",
																						}}
																						className="align-content-center me-3 mt-1"
																						onClick={(e) =>
																							handleDeleteClick(e,
																								assetTemplate._id,
																								rowIndex
																							)
																						}
																					>
																						<img
																							style={{ width: "25px" }}
																							src={trash}
																							alt="delete"
																						/>
																					</button>
																				</>
																			)}
																		</td>
																	</tr>
																))}

															{(!rows[assetTemplate._id] ||
																rows[assetTemplate._id].length === 0) && (
																	<tr>
																		<td colSpan="100%" className="text-center">
																			<p style={{ color: "#dc3545" }}>
																				No data available.
																			</p>
																		</td>
																	</tr>
																)}
														</tbody>
													</table>
													<div
														className="text-center"
														style={{ margin: "1vh", color: "#dc3545" }}
													>
														{errforsubmit}
													</div>
												</div>
											</div>
										))}
								</div>

								<div className="addEuipment-footer">
									<button
										type="button"
										className="addEuipment-discard-btn"
										onClick={() => navigate("/all_assets")}
									>
										Discard
									</button>
									<button type="submit" className="addEuipment-update-btn">
										Update
									</button>
								</div>
							</form>
						</div>
						<div
							id="overlay"
							className={`modal fade ${showUploadModal ? "show" : ""}`}
							tabIndex="-1"
							role="dialog"
							style={{
								zIndex: 30,
								display: showUploadModal ? "block" : "none",
								transition: "width 2s",
							}}
						>
							{loading ? (
								<Loader />
							) : (
								<div className="addunit-card Width 25%">
									<div className="addunit-header">
										<h4>Bulk Add Data</h4>
										<button
											style={{ border: "none", backgroundColor: "inherit" }}
											type="button"
											className="close"
											onClick={handleCloseUploadModal}
										>
											<img src={close} width="28px" height="28px" alt="Close" />
										</button>
									</div>

									<form autoComplete="off">
										<div className="addunit-form">
											<div className="mb-5">
												<div className="d-flex justify-content-between">
													<p className="addunit-form-text"></p>
													<div className="d-flex justify-content-between">
														<button
															style={{
																border: "none",
																backgroundColor: "transparent",
																display: "flex",
																alignItems: "center",
															}}
															className="align-content-center me-3 mt-1"
															onClick={() => downloadExcel(selectedTemplateId)}
														>
															<p className="addunit-form-text mt-3 mb-3">
																Download Template
															</p>
															<img
																style={{ width: "25px", marginLeft: "8px" }}
																src={lucide_download}
																alt="Download"
															/>
														</button>
													</div>
												</div>
												<div>
													<label className="file" style={{ height: "50px" }}>
														<input
															type="file"
															id="fileInput"
															ref={fileInputRef}
															aria-label="File browser example"
															onChange={handleFileChange}
														/>
														<span className="file-custom" id="fileName">
															{selectedFile ? selectedFile.name : "No file chosen"}
														</span>
													</label>
													<div
														style={{
															color: "#dc3545",
															width: "450px",
															paddingLeft: "10px",
															marginTop: "10px",
															marginBottom: "10px"
														}}
													>
														{errorrowMessages

														}
														{errorMessages.length > 0 && (
															<ul>
																{errorMessages.map((msg, index) => (
																	<li key={index}>{msg}</li>
																))}
															</ul>
														)}
													</div>
													<p
														className="mx-2 mt-0 "
														style={{
															fontSize: "15px",
															color: "gray",
															paddingBottom: "0px",
														}}
													>
														Upload format can be XLS or CSV file
													</p>
												</div>
											</div>
										</div>

										<div className="addunit-card-footer justify-content-between">
											<button
												type="button"
												className="discard-btn"
												onClick={handleCloseUploadModal}
											>
												Close
											</button>
											<button
												id="openPopup"
												className="update-btn"
												onClick={(e) => uploadExcel(e, selectedTemplateId)}
											>
												Add
											</button>
										</div>
									</form>
								</div>
							)}
						</div>
					</div>
					<ToastContainer
						position="top-right"
						autoClose={3000}
						hideProgressBar={false}
					/>
				</div>
			)}
		</>
	);
};

export default EditEquipment;
